import { DeleteIcon, EditIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Group } from '@components/layout';
import { useModal } from '@components/modal';
import type { Secret } from '@generated/graphql';
import type { MouseEvent } from 'react';
import { useDeleteSecretModal } from './DeleteSecretModal';
import { EditSecretModal } from './EditSecretModal';

type SecretControlsProps = {
  secret: Secret;
  onChange: VoidFunction;
};

export const SecretControls = ({ secret, onChange }: SecretControlsProps) => {
  const { showModal: showEditSecretModal } = useModal({
    component: EditSecretModal,
    componentProps: { secret, onEdit: onChange },
    modalProps: { title: `Edit ${secret?.name || 'secret'}` },
  });

  const handleEditSecret = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    return showEditSecretModal();
  };

  const { showModal: showDeleteSecretModal } = useDeleteSecretModal({
    secret,
    onDelete: onChange,
  });

  const handleDeleteSecret = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    return showDeleteSecretModal();
  };

  return (
    <Group alignItems="center" justifyContent="flex-end" flex={1} flexShrink={0} gap={1}>
      <IconButton
        Icon={EditIcon}
        tooltip="Details"
        onClick={handleEditSecret}
        size={16}
        variant="default"
      />
      <IconButton
        Icon={DeleteIcon}
        tooltip="Delete"
        onClick={handleDeleteSecret}
        size={16}
        variant="error"
      />
    </Group>
  );
};
